import { NavLink } from 'react-router-dom';
import { BarChart3, GraduationCap, Guitar, House } from 'lucide-react';
import { t } from '@/i18n';
import type { TranslationKey } from '@/i18n';

const ITEMS: { to: string; labelKey: TranslationKey; Icon: typeof House; end?: boolean }[] = [
  { to: '/', labelKey: 'nav.home', Icon: House, end: true },
  { to: '/training', labelKey: 'nav.training', Icon: GraduationCap },
  { to: '/chords', labelKey: 'nav.chords', Icon: Guitar },
  { to: '/progress', labelKey: 'nav.progress', Icon: BarChart3 },
];

/** Four destinations. No profile, no store, no settings tab. */
export function BottomNav() {
  return (
    <nav className="nav" aria-label={t('nav.home')}>
      <ul className="nav__list">
        {ITEMS.map(({ to, labelKey, Icon, end }) => (
          <li key={to} className="nav__item">
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) => `nav__link${isActive ? ' nav__link--active' : ''}`}
            >
              <Icon size={24} aria-hidden="true" />
              <span className="nav__label">{t(labelKey)}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
